import { memo } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import FormulaList from './select';

const FormulaGenericDeclarationComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <FormulaList
          value={formContext.values.formula}
          onChange={(formulas) => {
            const declarationFormula = formulas?.reduce(
              (prev, next) => (prev ? `${prev} \r\n ${next.value}` : next.value),
              ''
            );

            formContext.setValues({
              ...formContext.values,
              formula: formulas || [],
              declarationFormula: declarationFormula,
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Dichiarazione"
          aria-label="Dichiarazione"
          id="declaration-formula"
          fullWidth
          multiline
          inputProps={{
            spellCheck: true,
            lang: 'it',
          }}
          rows={5}
          value={formContext.values?.declarationFormula || ''}
          onChange={(event) => {
            formContext.setFieldValue('declarationFormula', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

FormulaGenericDeclarationComponent.displayName = 'Formula Generic Declaration component';

const FormulaGenericDeclaration = memo(FormulaGenericDeclarationComponent);

export default FormulaGenericDeclaration;
